import { useRef } from "react"
import { AnimatePresence, motion, useInView } from "motion/react"

export function BlurFade({ children, className, duration = 0.4, delay = 0, offset = 6, inView = false }) {
  const ref = useRef(null)
  const inViewResult = useInView(ref, { once: true, margin: "-50px" })
  const visible = !inView || inViewResult
  return (
    <AnimatePresence>
      <motion.div
        ref={ref}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        exit="hidden"
        variants={{
          hidden: { y: -offset, opacity: 0, filter: "blur(6px)" },
          visible: { y: 0, opacity: 1, filter: "blur(0px)" },
        }}
        transition={{ delay: 0.04 + delay, duration, ease: "easeOut" }}
        className={className}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
